module.exports = "/packs/images/map-pin~cac985d4055025fa5b3c98e5d7250870.png";